import { noop } from 'lodash';
import { PropsWithChildren } from 'react';

export abstract class AuthenticationProvider {
	protected onAuthenticatedCallback: (
		isAuth: boolean,
		message?: string
	) => void = noop;

	public abstract getTokenAsync(): Promise<string>;

	public abstract isAuthenticated(): Promise<boolean>;

	public getComponent(): (props: PropsWithChildren) => React.JSX.Element {
		return AuthenticationProvider.getDefaultComponent();
	}

	public static getDefaultComponent(): (
		props: PropsWithChildren
	) => React.JSX.Element {
		return ({ children }) => <>{children}</>;
	}

	public onAuthenticated(
		fn: (isAuth: boolean, message?: string) => void
	): void {
		this.onAuthenticatedCallback = fn;
	}
}
